module.exports = __webpack_public_path__ + "img/Icon_Docbit_peq.89f52628.png";